/* istanbul ignore file */
import { useDispatch, useSelector } from 'react-redux';
import { createSettingsService } from 'common/services/settings.service';
import { settingsSelector } from 'state/selectors/settings';
import { updateSetting as updateSettingCaller } from 'state/callers/settings';
import { myAccountSelector } from 'state/selectors/account';
import { getAllSettingsSucceed } from '../../state/actions';
import { toggleSnackBar } from '../../state/callers';

const useSettingsService = () => {
  const settings = useSelector(settingsSelector);
  const account = useSelector(myAccountSelector);
  const dispatch = useDispatch();
  const updateSettingsReducer = settings =>
    dispatch(getAllSettingsSucceed(settings));
  const toggleSnackBars = params => dispatch(toggleSnackBar(params));
  const updateSetting = ({ name, value, params }) =>
    dispatch(updateSettingCaller({ name, value, params }));

  return createSettingsService(
    settings,
    updateSetting,
    updateSettingsReducer,
    account,
    toggleSnackBars
  );
};

export default useSettingsService;
